import Utils from 'utilities/helper.util';

export const convertData = (
  data: any[],
  isDaily: boolean,
  startDate: string,
  range: string
) => {
  const newData = [];
  switch (range) {
    case 'today': {
      for (var i = 0; i < 24; i++) {
        const hour = i < 10 ? `0${i}` : i;
        const date = `${hour}:00:00`;
        newData.push(date);
      }
      break;
    }
    case 'this-week':
    case 'last-7-days': {
      const firstDate = Utils.getNewDate(`${startDate} 00:00:00`);
      newData.push(firstDate.format('YYYY-MM-DD'));
      for (i = 1; i < 7; i++) {
        newData.push(firstDate.add(i, 'day').format('YYYY-MM-DD'));
      }
      break;
    }
    case 'last-30-days': {
      const firstDate = Utils.getNewDate(`${startDate} 00:00:00`);
      newData.push(firstDate.format('YYYY-MM-DD'));
      for (i = 1; i < 30; i++) {
        newData.push(firstDate.add(i, 'day').format('YYYY-MM-DD'));
      }
      break;
    }
    default: {
      break;
    }
  }
  return newData.map((element: any) => {
    const dataDateObj = data.find((obj) =>
      isDaily ? obj.day === element : obj.hour === element
    );
    const date = isDaily
      ? Utils.getNewDate(`${element} 00:00:00`).utc().format()
      : Utils.getNewDate(`${startDate} ${element}`).utc().format();
    return {
      group: 'enquiry',
      date,
      value: dataDateObj?.count || 0
    };
  });
};

export const getTicksFormatter = (t: any, range: string) => {
  switch (range) {
    case 'today': {
      const date = Utils.getNewDate(t);
      return date.format('HH:00');
    }
    case 'this-week': {
      const date = Utils.getNewDate(t);
      return date.format('ddd');
    }
    case 'last-7-days':
    case 'last-30-days': {
      const date = Utils.getNewDate(t);
      return date.format('D/M');
    }
    default: {
      return t;
    }
  }
};

export const customToolTipHtml = (items: any[], range: string) => {
  if (items.length > 0) {
    const item = items[0];
    return `
        <ul class='multi-tooltip'>
          <li>
            <div class="datapoint-tooltip ">
              <p class="label">${range === 'today' ? 'Time' : 'Day'}</p>
              <p class="value">${
                range === 'today'
                  ? Utils.getNewDate(item.date).format('ha')
                  : Utils.toLocalDateFormat(item.date)
              }</p>
            </div>
          </li>
          <li>
            <div class="datapoint-tooltip ">
              <p class="label">Count</p>
              <p class="value">${item.value}</p>
            </div>
          </li>
        </ul>
      `;
  }

  return '';
};
